export default "__VITE_ASSET__CnasYAQf__"